import { createSelector } from 'reselect';
import { playerStatsSelector } from './simple-selectors';

export const playerStatsDataTypeSelector = createSelector(
    playerStatsSelector,
    (playerStats) => playerStats.dataType
);
